{
  "nl": {
    "overview": {
      "actions": {
        "select_decision": "Selecteer beslissing",
        "select_installment": "Selecteer betaalschijf",
        "select_point_list": "Selecteer puntenlijst",
        "select_survey": "Selecteer enquête"
      },
      "table": {
        "labels": {
          "category": "Categorie",
          "level": "Niveau",
          "project": "Project",
          "status": "Status",
          "unit": "Unit"
        }
      }
    }
  }
}
